export default __webpack_public_path__ + "static/testimony-dc8243da66e149bc42e23b45e26632ba.jpg";